import { Pipe, PipeTransform } from '@angular/core';
import {formatCurrency} from "@angular/common";

@Pipe({
  name: 'dollar',
  standalone: true
})
export class DollarPipe implements PipeTransform {
  transform(value: number): string {
    return formatCurrency(value, 'en-US', '$', 'USD', '1.0-0');
  }

}
